import {addBaseQueryParams, BaseQueryParams} from "@commons/utils/APIParams";
import axios from "axios";
import {config} from "@commons/config.instance";
import {IstitutoContrattualeRecord} from "@commons/mapping/IstitutoContrattualeRecord";
import {SaldoICRecord} from "@commons/mapping/SaldoICRecord";

/* ********* ISTITUTI CONTRATTUALI AZIENDA ********* */
export interface IstitutiContrParams extends Partial<BaseQueryParams> {
    idAziendaTabelle: number,
}

//https://fpnet2.ericed.it/FPNet2021/azienda/1/tabella/istituto?auth_token=1ef48da76841b7728856ed39b8dd6324&nowId=1684232812088&view=StatusGiustificativo
export const listIstitutiContrattuali = (p: IstitutiContrParams) => {
    const params: string[] = addBaseQueryParams(p);
    params.push('view=StatusGiustificativo');
    const finalUrl = config.getBaseUrl('FPNet') + `/azienda/${p.idAziendaTabelle}/tabella/istituto?${params.length > 0 ? encodeURI(params.join("&")) : ''}`;
    return axios<IstitutoContrattualeRecord[]>(finalUrl).then(res => {
        if (res.status === 200) {
            const lista = res.data;
            return lista.length > 0 ? lista : null;
        } else
            return null;
    })
}

/* ********* RIEPILOGO ISTITUTI CONTRATTUALI DIPENDENTE ********* */
export interface RiepilogoICParams extends Partial<BaseQueryParams> {
    idAziendaMaster: number,
    idDip: number,
    anno: number,
    mese: number,
    rilevaMese?: boolean,
}

//https://fpnet2.ericed.it/FPNet2021/preSTD/ic/1/saldo/52192?auth_token=1ef48da76841b7728856ed39b8dd6324&nowId=1684232966343&anno=2023&isValid=true&mese=5
export const listRiepilogoIC = (p: RiepilogoICParams) => {
    let params: string[] = addBaseQueryParams(p);
    //if (p.anno) params.push('anno=' + DateTime.now().year());
    //if (p.mese) params.push('mese=' + (DateTime.now().month() + 1));
    if (p.anno) params.push('anno=' + p.anno);
    if (p.mese) params.push('mese=' + p.mese);
    if (p.rilevaMese)
        params.push('rilevaMese=' + p.rilevaMese ? 'true' : 'false'); //Per avere i saldi attualizzati, passare a true
    else
        params.push('rilevaMese=true'); //Per avere i saldi attualizzati, passare a true

    const finalUrl = config.getBaseUrl('FPNet') + `/preSTD/ic/${p.idAziendaMaster}/saldo/${p.idDip}?${params.length > 0 ? encodeURI(params.join("&")) : ''}`;
    return axios<SaldoICRecord[]>(finalUrl).then(res => {
        if (res.status === 200)
            return res.data;
        else
            return null;
    })
}